module.exports = __webpack_public_path__ + "static/media/next.edeea8b2.svg";